import { isValidEmail } from '@/utils/util'

export const GIFT_CARD_MIN_AMOUNT = 5000
export const GIFT_CARD_MAX_AMOUNT = 500000
export const GIFT_CARD_PRESETS = [10000, 50000, 100000, 200000]

export function formatDateTimeForServer(date: Date | null): string | null {
  if (!date) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export type GiftCardFormState = {
  giftCardTemplateId: string
  amount: string
  senderEmail: string
  fullName: string
  email: string
}

export function validateGiftCardStep(step: number, state: GiftCardFormState): string | null {
  if (step === 0) {
    if (!state.giftCardTemplateId) return 'Бэлгийн картын загварыг сонгоно уу'
  }
  if (step === 1) {
    if (!state.amount) return 'Бэлгийн картын дүнг оруулна уу'
    const n = parseFloat(state.amount)
    if (isNaN(n) || n < GIFT_CARD_MIN_AMOUNT || n > GIFT_CARD_MAX_AMOUNT) {
      return `Бэлгийн картын дүн ${GIFT_CARD_MIN_AMOUNT}₮-${GIFT_CARD_MAX_AMOUNT}₮ хооронд байх ёстой`
    }
  }
  return null
}

export function validateGiftCardForm(state: GiftCardFormState): string | null {
  if (!state.giftCardTemplateId) return 'Бэлгийн картын загварыг сонгоно уу'
  if (!state.amount) return 'Бэлгийн картын дүнг оруулна уу'
  const n = parseFloat(state.amount)
  if (isNaN(n) || n <= 0) return 'Бэлгийн картын үнийн дүн буруу байна'
  if (n < GIFT_CARD_MIN_AMOUNT || n > GIFT_CARD_MAX_AMOUNT) {
    return `Бэлгийн картын дүн ${GIFT_CARD_MIN_AMOUNT}₮-${GIFT_CARD_MAX_AMOUNT}₮ хооронд байх ёстой`
  }
  if (!state.senderEmail) return 'Өөрийн и-мэйл хаягаа оруулна уу'
  if (!state.fullName) return 'Хүлээн авагчийн нэрийг оруулна уу'
  if (!state.email) return 'Хүлээн авагчийн и-мэйл хаягийг оруулна уу'
  if (!isValidEmail(state.senderEmail)) return 'Таны и-мэйл хаяг буруу байна'
  if (!isValidEmail(state.email)) return 'Хүлээн авагчийн и-мэйл хаяг буруу байна'
  return null
}
